import { cn } from '@/lib/utils'

interface RequestStatusProps {
  name?: string
  color?: string
}

export const RequestStatus = ({ color, name }: RequestStatusProps) => {
  return <p className={cn('italic text-base font-bold', color)}>({name})</p>
}
